import BodyText from './BodyText';

export { Props } from './BodyText';
export default BodyText;
